// profesorConfigStore.js — opciones del SIMULADOR de autoescuela para los avisos a profesores y el plazo de
// confirmación (9/10/2026), en memoria. En la app real son campos de c_autoescuela_config:
//   · semana_profesores.enabled       («Semana a profesores» en Planificación; apagado de fábrica)
//   · horario_manana_profesores       («Horario de mañana a los profesores» en Mensajes automáticos; apagado)
//   · plazo_confirmacion              («Si no confirma a tiempo» en Mensajes automáticos; apagado)
//   · repetir_confirmacion            («Volver a pedir confirmación», 26/10/2026; apagado)
//   · aviso_profesor                  («Avisar al profesor de los cambios de sus alumnos», 14/10/2026; apagado)
// Los leen Planificación (modal y enlace) y Mensajes automáticos (tarjetas), así que viven fuera de las dos páginas.
import { useSyncExternalStore } from "react";
import { normalizaHorarioManana, normalizaPlazo, normalizaRepetir } from "../mensajes/avisosHorarioConfig";
import { normalizaAvisoProfesor } from "./avisoProfesorCambio";

const fabrica = () => ({
  semanaProfesores: false,
  horarioManana: normalizaHorarioManana(null),
  plazoConfirmacion: normalizaPlazo(null),
  repetirConfirmacion: normalizaRepetir(null),
  avisoProfesor: normalizaAvisoProfesor(null),
});
let _cfg = fabrica();
const _subs = new Set();
const emit = () => _subs.forEach((fn) => { try { fn(); } catch { /* noop */ } });

export const getProfesorConfig = () => _cfg;
export function subscribeProfesorConfig(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
export function useProfesorConfig() {
  return useSyncExternalStore(subscribeProfesorConfig, getProfesorConfig, getProfesorConfig);
}
export function setProfesorConfig(patch) {
  _cfg = { ..._cfg, ...patch };
  emit();
}
export function resetProfesorConfig() {
  _cfg = fabrica();
  emit();
}
